<template>
  <div>
    <section class="main-content">
        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title"><span>頂上故事 (Top Stories)</span></h3>
                            <div class="articles-items">
                                <div class="row">
                                    <div class="col-xl-4 col-lg-4 col-md-6" v-for="(row, index) in featured">
                                        <div class="articles-box news-box">
                                            <a :href="'/featured/'+row.id">
                                                <div class="text text-center">
                                                    <h5 class="title text-primary">{{row.title}}</h5><br/>
                                                    <p class="featured mb-0" v-html="row.context"></p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'featured',
  data () {
    return {
      uri: this.$store.getters.getUri,
      featured: Object
    }
  },
  computed: {
    ...mapGetters([
      'getUri'
    ])
  },
  mounted: function () {
    let self = this
    this.$http.get(this.uri + 'Article/getArticle').then(function (res) {
      let data = res.data
      if (data.status === 200) {
        self.featured = data.articles
      } else {
        console.log('下載頂上文章失敗')
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Featured.vue?290595dd